import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { localStorageRemove, localStorageSet } from 'utils/localStorage';

export interface TaskSetFilters {
  planned?: string | null;
  assigned?: string | null;
  taskSetStatus?: string[] | null;
  taskType?: string | null;
  companiesList?: string[] | null;
  regionsList?: string[] | null;
  popOwner?: string[] | null;
  search?: string | null;
}

// export type FiltersState = Record<string, TaskSetFilters>;

export interface FilterPayload {
  userId: string;
  key: keyof TaskSetFilters;
  value: any;
}

const initialState: TaskSetFilters = {
  planned: null,
  assigned: null,
  taskSetStatus: null,
  taskType: null,
  companiesList: null,
  regionsList: null,
  popOwner: null,
  search: null,
};

const filtersSlice = createSlice({
  name: 'tasksetFilters',
  initialState,
  reducers: {
    // data initialization from the localStorage
    setInitialFilters: (state, action: PayloadAction<TaskSetFilters>) => {
      return action.payload;
    },

    // The universal action to update any field
    setFilter(state, action: PayloadAction<FilterPayload>) {
      const { userId, key, value } = action.payload;
      state[key] = value;

      const hasFilters = Object.values(state).some(value => !!value);
      if (hasFilters) {
        localStorageSet(`tasksetFilters_${userId}`, state);
      } else {
        localStorageRemove(`tasksetFilters_${userId}`);
      }
      return state;
    },

    clearFilterStorage() {
      return initialState;
    },

    // Resetting the filters
    resetFilters(state, action: PayloadAction<string>) {
      const userId = action.payload;
      localStorageRemove(`tasksetFilters_${userId}`);
      return initialState;
    },
  },
});

export const { setInitialFilters, setFilter, clearFilterStorage, resetFilters } = filtersSlice.actions;
export default filtersSlice.reducer;
